import CardImageMarkers from "../../../../components/CockpitCards/CardImageMarkers";
import { hormone } from "../../../../constants";


export default function HormoneCard() {
  

return (

    <CardImageMarkers 
    
        image={hormone}
        title="HORMONAL BALANCE"
        subtitle="Feel good and make your day"
        markersTitle=""
        markers="Estradiol, Testosteron"

    />


)
}